<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li><a href="/questao" title="Pages">Questões</a></li>
                            <li>Editar</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Editar Questões</b></h2>
                    </div>

                    <b-tabs v-if="dialogEdit">
                        <b-tab title="Dados principais" active>
                            <br />
                            <div class="mold-txt-center">
                                <form-edit :id="questaoId" @on-saved="onSaved" @on-back="onBack()" />
                            </div>
                        </b-tab>

                        <b-tab title="Perguntas">
                            <br />
                            <questao-pergunta :questao-id="questaoId" />
                        </b-tab>

                        <b-tab title="Tags">
                            <br />
                            <questao-tag-jobs :questao-id="questaoId" />
                        </b-tab>

                    </b-tabs>
                </div>
            </div>
        </section>
    </main>

</template>
<script>

    import formEdit from './form-edit'
    import questaoTagJobs from './questaotagjobs'
    import questaoPergunta from './questaopergunta'

    export default {
        name: 'questao-edit',
        components: { formEdit, questaoPergunta, questaoTagJobs },
        data: () => ({
            dialogEdit: false,
            questaoId: 0
        }),
        methods: {
            onSaved: function (data) {
                if (data) this.$router.push({ path: '/questao' });
            },
            onBack: function () {
                this.$router.go(-1);
            }
        },
        mounted() {
            this.questaoId = +this.$route.params.id;
            this.dialogEdit = true;
        }
    };
</script>

